_getEventList